module.exports = __webpack_public_path__ + "img/background_1.138aa086.jpg";